import * as React from 'react';

import { ArticleHeading2, UIText1, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';

import * as styles from './DesktopGenericService.css';
import { IGenericServiceProps } from '../GenericService';

export const DesktopGenericService = ({
  onClick,
  bgColor,
  checked,
  title,
  subtitle,
  dataName,
  unavailable,
  icon,
  description,
  children,
}: IGenericServiceProps) => (
  <div
    data-name={dataName}
    className={classNames(
      styles['card'],
      styles[bgColor],
      checked && styles['checked'],
      unavailable && styles['unavailable'],
    )}
    onClick={onClick}
  >
    <div className={styles['header']}>
      <div>
        <ArticleHeading2>{title}</ArticleHeading2>
        {subtitle && <UIText1>{subtitle}</UIText1>}
      </div>

      {icon}
    </div>

    <div className={classNames(styles['description'], !subtitle && styles['without_subtitle'])}>
      {description.map((item, index) => (
        <div key={index} className={styles['description_item']}>
          <UIText2>
            <div className={styles['info-row']}>
              <div className={styles['info-row-dot']} />
              {item}
            </div>
          </UIText2>
        </div>
      ))}
    </div>

    <div className={styles['footer']}>{children}</div>
  </div>
);
